module.exports = "<h2>Hi, Please Please Read This!</h2>\n\n<h3>This is a beta preview</h3>\n\n<p>I built this app and I'd like to get it out into the world. But first I need to iron out the wrinkles.</p>\n\n<div\n\t*ngIf=\"firebaseService.signedOut | async\"\n\tclass=\"sign-in-up-wrapper\"\n>\n\t<a class=\"sign-in\" routerLink=\"/signin\">Sign In</a>\n\t<a class=\"sign-up\" routerLink=\"/signup\">Sign Up</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/homepage/homepage.html
// module id = ../../../../../src/app/components/homepage/homepage.html
// module chunks = 1